<template>
  <div class="c-led-list-item px">
    <c-led-canvas
      class="led"
      :frames="frames"
      :speed="speed"
      @click="onComment"
    />
    <div class="info" @click="onComment">
      <div class="name">
        {{ led.name }}
      </div>
      <div class="description">
        {{ led.description }}
      </div>
    </div>
    <div
      class="icon"
      :class="{
        active: led.is_like,
      }"
      @click="onLike"
      v-if="(led.user_id && led.is_publish) || led.is_like"
    >
      <i class="iconfont iconaixin" />
      {{ led.like_count || "" }}
    </div>
    <div class="icon" @click="onComment" v-if="led.user_id && led.is_publish">
      <i class="iconfont iconhuabantaolun" />
      {{ led.comment_count || "" }}
    </div>
    <c-profile-turn class="icon" :content="content" type="download">
      <i class="iconfont icondownload-b" />
    </c-profile-turn>
    <c-profile-turn class="icon" :content="content" type="turn">
      <i class="iconfont iconrefresh" />
    </c-profile-turn>
    <a-dropdown v-if="isOwner">
      <a class="ant-dropdown-link" @click.prevent>
        <b class="icon">
          · · ·
        </b>
      </a>
      <div slot="overlay" class="c-led-actives px">
        <div class="c-led-edit" @click="onEdit">{{ $t("edit") }}</div>
        <div class="c-led-line"></div>
        <div class="c-led-delete" @click="onDelete">{{ $t("delete") }}</div>
      </div>
    </a-dropdown>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepCopy } from "@/utils";
import api from "@/api";

export default {
  name: "CLedListItem",
  props: {
    source: Object,
    onLiked: Function,
    onDeleted: Function,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("profile", {
      default: "default",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
      userId: "id",
    }),
    led() {
      return this.source;
    },
    isOwner() {
      return this.led.user_id === this.userId;
    },
    content() {
      try {
        const content = JSON.parse(this.led.config_text);
        return content;
      } catch {
        return null;
      }
    },
    frames() {
      return this.content?.frames?.frame_data || [];
    },
    speed() {
      return this.content ? this.content.speed_ms : 0;
    },
    data() {
      let lightEffects = deepCopy(this.default.lightEffects);
      lightEffects[4] = this.content;
      return {
        ...this.default,
        lightEffects,
      };
    },
  },
  methods: {
    onLike() {
      if (!this.isSignIn) {
        this.$store.dispatch("user/signIn");
      } else {
        if (this.led.is_like) {
          api.unlikeLED(this.led.id).then((res) => {
            this.led.like_count = res.count;
            this.led.is_like = false;
            this.onLiked();
          });
        } else {
          api.likeLED(this.led.id).then((res) => {
            this.led.like_count = res.count;
            this.led.is_like = true;
            this.onLiked();
          });
        }
      }
    },
    onComment() {
      this.led.user_id &&
        this.led.is_publish &&
        this.$router.push({
          path: this.$paths.led.replace(":id", this.led.id),
        });
    },
    onEdit() {
      this.$router.push({
        path: this.$paths.ledEdit.replace(":id", this.led.id),
      });
    },
    onDelete() {
      this.$confirm({
        title: this.$t("light.deleteConfirm"),
        onOk: () => {
          api.deleteLED(this.led.id).then(() => {
            this.$message.info(this.$t("light.deleteSuccess"));
            this.onDeleted();
          });
        },
        width: "8.4rem",
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.c-led-list-item.px {
  @include flex-center;
  flex-wrap: wrap;
  width: 800px;
  height: 200px;
  margin: 0 auto;
  padding: 20px;
  max-width: 100%;

  .led {
    width: 800px;
    height: 100px;
    border-bottom: 2px solid $primary-color;
    cursor: pointer;
  }

  .info {
    width: 100px;
    flex: auto;
    text-align: left;
    cursor: pointer;

    .name {
      font-size: 14px;
      font-weight: bold;
      color: #ffffff;
      line-height: 30px;
    }

    .description {
      @include nowrap;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .icon {
    @include flex-center;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    margin-left: 30px;

    &:hover,
    &.active {
      color: $primary-color;
    }
    &.disabled {
      color: #ffffff;
      cursor: not-allowed;
    }

    i {
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.c-led-actives.px {
  background: #5b5b5b;
  border: 1px solid #000000;
  border-radius: 10px;
  overflow: hidden;

  .c-led-edit,
  .c-led-delete {
    color: #ffffff;
    font-size: 16px;
    padding: 10px 25px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: $primary-color;
    }
  }
  .c-led-line {
    width: 68px;
    height: 1px;
    background: #878787;
    margin: 0 auto;
  }
}
</style>
